{
  "fr": {
    "apps": {
      "ai_assistant": {
        "color": "var(--brand-7)",
        "description": "Découvrez des 150+ Chatbots utiles pour vous et vos élèves.",
        "descriptionPupils": "Découvrez des 150+ Chatbots utiles pour vous et vos élèves.",
        "icon": "bi-grid-3x3",
        "longDescriptionHtml": "Avec cet outil, les élèves peuvent découvrir et interagir avec des personnages historiques ou fictifs. Ils peuvent interagir avec ces personnages dans des jeux de rôle, des projets d'écriture, des présentations et d'autres activités créatives pour mieux les comprendre.",
        "name": "Catalogue d'assistants IA",
        "useCasesHtml": "<ul> <li>Écriture créative : Les élèves peuvent écrire des essais ou des nouvelles où ils dialoguent avec des personnages historiques ou fictifs et partagent leurs pensées et sentiments.</li> <li>Conférences et présentations : Les élèves peuvent rechercher des personnages historiques ou fictifs et faire des présentations pour démontrer leur connaissance et compréhension et discuter de leurs personnalités.</li> <li>Jeux de quiz et de trivia : Les élèves peuvent jouer à des jeux de quiz ou de trivia où ils répondent à des questions sur des personnages historiques ou fictifs pour tester et approfondir leurs connaissances.</li> </ul>"
      },
      "ai_audio": {
        "description": "Faites lire des pistes audio de différentes sources.",
        "icon": "bi-soundwave",
        "name": "Faire lire un texte"
      },
      "ai_chat": {
        "customBadgeLabel": "avec Assistants IA",
        "description": "Utilisez l'IA génératrice de texte pour vous aider dans de nombreuses tâches.",
        "descriptionPupils": "Essayez de voir comment l'IA peut vous aider dans vos tâches d'apprentissage.",
        "longDescriptionHtml": "Laissez notre assistance IA vous aider à organiser votre enseignement et votre travail.",
        "name": "Chat IA",
        "useCasesHtml": "<ul> <li>Faites traduire des lettres aux parents en <strong>différentes langues</strong>.</li> <li>Faites créer des suggestions pour <strong>des tâches et des solutions types</strong>.</li> <li>Faites créer des <strong>listes de matériel</strong> pour des expériences.</li> <li>Faites résumer des textes complexes de manière <strong>brève et adaptée à l'âge</strong>.</li> <li>Faites planifier le <strong>déroulement de la réunion parents-professeurs</strong>.</li> <li>Faites rechercher les <strong>informations les plus importantes</strong> sur un sujet.</li> <li>Faites générer ou réviser des <strong>extraits de code</strong>.</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "ai_converter": {
        "description": "Créez des podcasts, des conférences, des pistes audio et des transcriptions à partir de différentes sources",
        "longDescriptionHtml": "Les Outils multimédia IA vous offrent de nouvelles possibilités pour créer et transformer des contenus pour votre enseignement.",
        "name": "Outils multimédia IA",
        "useCasesHtml": "<ul><li>Transformez des contenus en un <strong>podcast ou une conférence</strong> sur le sujet de votre choix - avec piste audio et transcription</li><li>Créez des <strong>exercices de compréhension orale</strong> pour votre enseignement et faites lire des pistes audio de différentes sources.</li><li><strong>Transformez des messages vocaux et des vidéos en texte</strong> et utilisez la transcription pour d'autres tâches.</li><li>Obtenez un texte continu à partir de photos et de textes de <strong>manuscrits</strong>.</li></ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "ai_dialog": {
        "description": "Faites lire des dialogues sous forme de podcasts avec deux locuteurs.",
        "icon": "bi-chat-quote",
        "name": "Faire lire un dialogue"
      },
      "ai_document_qa": {
        "description": "Posez des questions sur des documents et faites résumer les contenus avec l'IA.",
        "descriptionPupils": "Posez des questions sur les contenus de PDFs et faites préparer les contenus facilement.",
        "longDescriptionHtml": "Recherchez des informations dans des documents spécifiques et faites-les préparer de manière ciblée.",
        "name": "Discuter avec un PDF",
        "useCasesHtml": "<ul> <li>Posez des questions sur l'ensemble des contenus d'un PDF.</li> <li>Faites résumer les points les plus importants d'une source dans la longueur souhaitée.</li> <li>Recherchez des contenus dans des documents et faites-les préparer dans la forme souhaitée.</li> <li>Obtenez un plan détaillé des contenus d'un PDF.</li> <li>Faites créer des paires de questions-réponses prêtes pour des tests et des contrôles de connaissances basés sur une source spécifique.</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "ai_feedback": {
        "description": "Obtenez des suggestions d'évaluation générées par l'IA basées sur vos critères.",
        "longDescriptionHtml": "Gagnez un temps précieux lors de la correction grâce à la correction d'erreurs et aux suggestions d'évaluation assistées par l'IA.",
        "name": "Aide à la correction",
        "useCasesHtml": "<ul> <li>Obtenez des listes d'erreurs générées par l'IA et des pré-corrections pour les textes des élèves.</li> <li>Définissez vos propres critères d'évaluation et recevez des retours individuels et des suggestions d'amélioration.</li></ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "ai_feedback_result": {
        "name": "Résultats de l'aide à la correction"
      },
      "ai_image": {
        "description": "Créez des images à partir de descriptions textuelles avec l'aide de l'IA génératrice d'images.",
        "descriptionPupils": "Expérimentez avec des descriptions et des styles et transformez-les en images créatives.",
        "longDescriptionHtml": "Faites transformer une idée en une <strong>image</strong> et illustrez des concepts et des idées en classe.",
        "name": "Générer une image",
        "useCasesHtml": "<ul> <li>Créez des images libres de droits pour <strong>illustrer des matériels pédagogiques</strong>.</li> <li>Obtenez <strong>plusieurs versions d'images</strong> et de motifs dans différents styles.</li> <li>Discutez avec les élèves des associations, des styles et des <strong>possibilités créatives</strong>.</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "ai_lecture": {
        "description": "Obtenez une courte conférence sur le sujet de votre choix - avec piste audio et transcription.",
        "icon": "bi-book",
        "name": "Créer un exposé"
      },
      "ai_message": {
        "name": "Laboratoire de prompts"
      },
      "ai_mini_tool": {
        "customBadgeLabel": "55+ Prompts",
        "description": "Utilisez des prompts prêts à l'emploi pour accomplir rapidement des tâches variées.",
        "icon": "bi-lightbulb",
        "longDescriptionHtml": "Plus de 55+ Prompts prêts à l'emploi te déchargent des tâches récurrentes du quotidien scolaire - de la planification des cours à la communication avec les parents, sans avoir à écrire toi-même des prompts.",
        "name": "Laboratoire de prompts",
        "useCasesHtml": "<ul> <li>Planifie des <strong>séries de cours et des leçons individuelles</strong> adaptées à la matière, au niveau de classe et au sujet.</li> <li>Crée des <strong>matériaux et des tâches</strong> en quelques secondes avec peu d'informations.</li> <li>Trouve des <strong>idées de différenciation</strong> pour adapter les tâches à différents niveaux.</li> <li>Formule des <strong>feedbacks et évaluations</strong> avec des aides à la formulation appropriées.</li> <li>Prépare des <strong>entretiens avec les parents et des e-mails</strong> de manière claire et avec le bon ton.</li> <li>Obtiens des <strong>idées créatives de projets et de cours</strong> pour un nouvel apport.</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "ai_mini_tool_request": {
        "name": "Demandes du laboratoire de prompts"
      },
      "ai_my_assistants": {
        "description": "Créez vos propres chatbots avec des \"connaissances de fond\" et des instructions précises.",
        "icon": "bi-stars",
        "name": "Mes assistants IA"
      },
      "ai_persona": {
        "description": "Discutez avec des chatbots de différents personnages et figures.",
        "descriptionPupils": "Chattez avec des personnes passionnantes et célèbres ou avec des personnages amusants.",
        "longDescriptionHtml": "Laissez l'IA endosser d'autres rôles que vous pouvez interroger sur leurs connaissances et expériences.",
        "name": "Chatbot jeu de rôle",
        "useCasesHtml": "<ul> <li>Discutez avec des <strong>personnalités historiques</strong> sur les événements passés.</li> <li><strong>Apprenez des expert·e·s</strong> dans un domaine spécifique et interrogez-les sur leurs expériences.</li> <li>Conduisez une <strong>interview avec des écrivain·e·s</strong> sur l'histoire et les coulisses de leurs œuvres.</li> <li>Testez avec des <strong>personnages amusants</strong> les possibilités et les limites de l'intelligence artificielle.</li> <li>Choisissez votre personne ou personnage préféré·e comme coach d'apprentissage et demandez-lui des <strong>conseils pour votre processus d'apprentissage</strong> ou une tâche concrète.</li> </ul>"
      },
      "ai_podcast": {
        "description": "Transformez des contenus en une conversation à écouter - avec piste audio et transcription.",
        "icon": "bi-mic",
        "name": "Créer un podcast"
      },
      "ai_summary": {
        "description": "Créez un résumé à partir d'un texte, d'un site web ou d'autres sources.",
        "icon": "bi-journal-text",
        "name": "Créer un résumé"
      },
      "ai_text": {
        "description": "Transformez des textes à partir d'images ou de documents en texte continu.",
        "icon": "bi-file-earmark-font",
        "name": "Reconnaître du texte à partir d'une image ou d'un fichier"
      },
      "ai_transcript": {
        "description": "Transformez le texte de pistes audio ou de vidéos YouTube en transcriptions.",
        "icon": "bi-vector-pen",
        "name": "Créer une transcription"
      },
      "ai_translation": {
        "description": "Créez une traduction à partir d'un texte, d'un site web ou d'autres sources.",
        "icon": "bi-translate",
        "name": "Traduire un texte"
      },
      "audio_recorder": {
        "description": "Créez des enregistrements audio et partagez-les numériquement et en toute sécurité avec les élèves.",
        "icon": "bi-file-music",
        "longDescriptionHtml": "Créez des enregistrements audio et partagez-les ensuite avec un lien ou un QR code.",
        "name": "Enregistrement audio",
        "useCasesHtml": "<ul> <li>Donnez un <strong>feedback audio</strong> sur les devoirs, les projets et les travaux de classe</li> <li>Partagez des indices cachés par message audio lors d'un EduBreakout</li> <li>Fournissez des <strong>aides auditives supplémentaires</strong>, par exemple pour les élèves ayant des difficultés de lecture</li> <li>Envoyez des messages de salutation et des messages vocaux aux élèves</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "classroom_screen": {
        "description": "Créez des tableaux multimédias, intégrez des contenus et partagez-les numériquement.",
        "longDescriptionHtml": "Créez des tableaux multimédias et structurez vos contenus pédagogiques. Animez votre enseignement en direct et numériquement.",
        "name": "Tableau numérique",
        "useCasesHtml": "<ul> <li>Visualisez les contenus pédagogiques et enrichissez-les <strong>avec des contenus multimédias</strong></li> <li>Notez et structurez les contenus et éléments sur un <strong>tableau dynamique</strong></li> <li><strong>Collectez des idées ensemble</strong> avec vos élèves</li> <li>Expliquez et partagez des consignes de travail de manière claire sur le tableau numérique</li> <li>Une horloge numérique, un minuteur et des symboles pour les phases de travail vous aident à <strong>structurer votre enseignement</strong></li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "file_sharing": {
        "description": "Téléchargez des fichiers et partagez-les numériquement et en toute sécurité avec les élèves.",
        "longDescriptionHtml": "Téléchargez n'importe quel fichier et partagez-le ensuite avec un lien ou un QR code.",
        "name": "Partager un fichier",
        "useCasesHtml": "<ul> <li>Partagez des fiches d'exercices et des devoirs <strong>facilement et en toute sécurité</strong> avec les élèves</li> <li>Distribuez des <strong>matériels pédagogiques</strong> et des <strong>consignes de travail</strong> dans des classes équipées de tablettes</li> <li>Accordez des droits d'accès temporaires à certains groupes d'apprentissage</li> <li>Échangez des plans de cours et des matériels avec des collègues</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "link_shortener": {
        "description": "Créez des liens courts pour des contenus numériques et partagez-les numériquement et en toute sécurité avec les élèves.",
        "longDescriptionHtml": "Raccourcir un lien et partagez-le ensuite avec un lien ou un QR code.",
        "name": "Raccourcir un lien",
        "useCasesHtml": "<ul> <li>Partagez des matériels pédagogiques, des vidéos ou des contenus numériques avec des <strong>liens sécurisés</strong></li> <li>Accordez des droits d'accès temporaires à des groupes d'apprentissage sélectionnés</li> <li>Sécurisez vos liens <strong>avec des mots de passe protégés</strong></li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "pinboard": {
        "defaults": {
          "boardName": "Tableau d'affichage",
          "cardName": "Carte n°1",
          "listName": "Première liste"
        },
        "description": "Créez des tableaux d'affichage interactifs et éditez-les ensemble avec les élèves.",
        "longDescriptionHtml": "Travaillez ensemble avec d'autres sur un tableau interactif. Utilisez des cartes pour partager des contenus de manière structurée.",
        "name": "Tableau d'affichage",
        "useCasesHtml": "<ul> <li>Créez des <strong>plannings hebdomadaires numériques</strong> avec des consignes de travail et des matériels pédagogiques</li> <li>Créez des plannings pour des événements numériques, hybrides ou en présentiel</li> <li>Créez des <strong>centres d'apprentissage</strong> pour certaines unités pédagogiques</li> <li>Sauvegardez les connaissances préalables des élèves sur un <strong>tableau interactif</strong></li> <li>Documentez les contenus et résultats pédagogiques ensemble avec les élèves</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "project": {
        "name": "Projets en classe"
      },
      "pupil_feedback": {
        "description": "Donnez aux élèves accès à un feedback individuel de l'IA sur leurs tâches.",
        "longDescriptionHtml": "Cet outil fournit aux élèves des retours générés par l'IA et des suggestions d'amélioration différenciées pour les textes et les tâches.",
        "name": "Feedback pour les élèves",
        "useCasesHtml": "<ul> <li>Accompagnez les tâches d'écriture de vos élèves avec un <strong>feedback basé sur l'IA</strong> en temps réel.</li> <li>Soutenez les élèves de manière autonome avec l'IA dans leur processus d'apprentissage et <strong>allégez-vous sensiblement.</strong></li> <li>Contrôlez le feedback généré par l'IA grâce à des <strong>critères définis individuellement</strong>.</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "qrcodes": {
        "description": "Créez des QR codes à partir de liens et intégrez-les dans des matériels pédagogiques.",
        "longDescriptionHtml": "Créez un QR code à partir d'une URL et partagez-le ensuite numériquement avec vos élèves.",
        "name": "Créer un QR code",
        "useCasesHtml": "<ul> <li>Partagez des matériels pédagogiques, des présentations ou des ressources numériques directement via des <strong>QR codes</strong></li> <li><strong>Facilitez l'accès</strong> aux sondages en ligne ou aux formulaires de feedback pour vos élèves</li> <li>Intégrez des QR codes dans des fiches d'exercices ou des affiches pour fournir des <strong>informations supplémentaires</strong></li> </ul>"
      },
      "school_class": {
        "description": "Créez une salle de classe où vos élèves peuvent travailler de manière autonome avec des outils sélectionnés.",
        "longDescriptionHtml": "Chaque élève dispose d'un espace personnel pour travailler sur une tâche ou un projet.",
        "name": "Salle de classe",
        "newFeaturesHtml": "<strong>Nouveau :</strong> Invite d'autres enseignant·e·s à tes projets, filtre les activités précisément, ajoute tes propres fichiers et relie des salles de classe à ton école.",
        "useCasesHtml": "<ul> <li>Testez et discutez avec les élèves des <strong>opportunités et des risques</strong> liés à l'utilisation de l'intelligence artificielle.</li> <li>Laissez les élèves utiliser le Chat IA comme <strong>co-pilote pour la création de textes</strong>.</li> <li>Permettez à vos élèves d'interroger l'IA sur un sujet spécifique et de <strong>vérifier et évaluer</strong> les résultats avec leurs connaissances préalables.</li> <li>Utilisez l'<strong>IA comme Study Buddy</strong> pour aider vos élèves dans une tâche ou un projet.</li> <li>Permettez aux élèves de mener une <strong>conversation avec des personnages historiques</strong> (ou des personnages amusants) à l'aide de l'IA.</li> </ul>",
        "useCasesTitle": "Voici comment l'utiliser :",
        "videoIntroText": "Comment configurer une salle de classe pas à pas est expliqué dans notre vidéo d'environ 5 minutes.",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "screen_recorder": {
        "description": "Créez des enregistrements d'écran et partagez-les en toute sécurité.",
        "longDescriptionHtml": "Créez des enregistrements d'écran et partagez-les ensuite avec un lien ou un QR code.",
        "name": "Enregistrement d'écran",
        "useCasesHtml": "<ul> <li>Créez des <strong>vidéos explicatives</strong> et des <strong>tâches par vidéo d'écran</strong></li> <li>Présentez l'utilisation de <strong>sites web</strong> ou de <strong>programmes</strong> dans un <strong>enregistrement d'écran</strong></li> <li>Donnez un <strong>feedback vidéo</strong> sur les devoirs, projets et travaux de classe soumis numériquement</li> <li>Élaborez une <strong>solution modèle</strong> dans une <strong>vidéo d'écran</strong></li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "surveys": {
        "description": "Créez des sondages, partagez-les et les résultats, et évaluez-les numériquement.",
        "icon": "bi-clipboard-data",
        "longDescriptionHtml": "Créez un sondage à remplir et choisissez parmi différents types de questions/tâches. Partagez le sondage avec un lien ou un QR code et évaluez les résultats.",
        "name": "Sondage",
        "useCasesHtml": "<ul> <li>Créez des <strong>sondages, formulaires</strong> et <strong>évaluations de connaissances</strong></li> <li>Interrogez les élèves sur leurs connaissances (préalables), opinions et auto-évaluations</li> <li>Créez des quiz et des évaluations de niveau, des exercices et des tâches</li> <li>Recueillez des <strong>feedbacks de cours</strong> numériquement et anonymement et évaluez-les en ligne</li> <li>Collectez les résultats numériquement et évaluez-les facilement et clairement</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "to_teach_worksheet_import": {
        "description": "Importez des fiches d'exercices depuis votre compte to teach directement dans fobizz.",
        "name": "Fiche d'exercices de to teach"
      },
      "text_editor": {
        "description": "Rédigez et éditez des documents texte avec les élèves - avec l'aide de l'IA.",
        "descriptionPupils": "Rédigez et éditez des documents texte ensemble.",
        "longDescriptionHtml": "Créez des documents texte sans connaissances techniques et partagez-les ensuite avec un lien ou un QR code.",
        "name": "Éditeur de texte",
        "useCasesHtml": "<ul> <li>Projets de groupe et brainstorming : les élèves peuvent travailler ensemble sur des projets et rassembler des idées ou des sujets à discuter en classe.</li> <li>Résumés et comptes rendus : les élèves peuvent rédiger ensemble des documents, organiser et structurer les contenus.</li> <li>Écriture créative et conférences d'écriture : les élèves peuvent rédiger, réviser et améliorer des textes personnels ou d'autres textes avec leurs camarades.</li> <li>IA : L'intelligence artificielle intégrée aide à la rédaction et à la révision des contenus et fournit des conseils en orthographe et grammaire ainsi qu'une aide à la traduction.</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "video_recorder": {
        "description": "Créez des enregistrements vidéo et partagez-les numériquement et en toute sécurité avec les élèves.",
        "longDescriptionHtml": "Créez des enregistrements vidéo et partagez-les ensuite avec un lien ou un QR code.",
        "name": "Enregistrement vidéo",
        "useCasesHtml": "<ul> <li>Créez des <strong>vidéos explicatives</strong> simples et des <strong>tâches par vidéo</strong></li> <li>Donnez un <strong>feedback vidéo</strong> sur les devoirs, projets et travaux de classe</li> <li>Fournissez des aides à l'apprentissage ou des tâches pour la différenciation interne par <strong>message vidéo</strong></li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "website": {
        "description": "Créez des sites web numériques simples, intégrez des contenus et partagez-les numériquement.",
        "icon": "bi-window",
        "longDescriptionHtml": "Créez un site web sans connaissances techniques et partagez-le ensuite avec un lien ou un QR code.",
        "name": "Site web",
        "useCasesHtml": "<ul> <li>Utilisez le site web comme une <strong>page blanche numérique</strong> que vous pouvez remplir avec des contenus libres</li> <li>Créez des <strong>mémos, lettres aux parents ou articles de blog</strong> et partagez-les avec les parents et les élèves</li> <li>Partagez une <strong>collection de liens</strong> sur un sujet spécifique</li> <li>Créez des <strong>parcours d'apprentissage et des comptoirs d'apprentissage</strong> avec des contenus multimédias</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "word_clouds": {
        "description": "Créez des nuages de mots avec des questions et des flashs et partagez-les numériquement.",
        "longDescriptionHtml": "Créez des nuages de mots à partir d'une liste de mots ou en collaboration avec vos élèves.",
        "name": "Nuage de mots",
        "newlineSeparatedWordsPlaceholder": "Quand\nles mouches\nvolent\naprès\nles mouches\nles mouches\nvolent\naprès\nles mouches",
        "useCasesHtml": "<ul> <li>Créez des nuages de mots comme entrée de cours activante </li> <li>Utilisez des nuages de mots <strong>pour un brainstorming créatif</strong> avec les élèves</li> <li>Interrogez les connaissances préalables ou les associations des élèves</li> <li>Recueillez des <strong>impressions</strong> en classe ou lors de réunions de parents</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "worksheet": {
        "consolidatedDescription": "Créer des fiches d'exercices soi‑même, les générer via l'IA ou les importer depuis to teach.",
        "description": "Créez des fiches d'exercices avec vos propres contenus, partagez-les et évaluez-les numériquement.",
        "longDescriptionHtml": "Créez une fiche d'exercices à remplir et choisissez parmi différents types de questions/tâches. Partagez votre fiche d'exercices avec un lien ou un QR code et évaluez les résultats en ligne.",
        "name": "Fiche d'exercices",
        "useCasesHtml": "<ul> <li>Créez des <strong>fiches d'exercices numériques</strong>, formulaires, évaluations de connaissances, quiz et évaluations de niveau</li> <li>Intégrez des questions à choix multiple, des textes à trous, des indices et des tâches libres en quelques clics</li> <li>Collectez les <strong>résultats numériquement</strong> et évaluez-les facilement et clairement en ligne</li> <li>Recueillez des feedbacks de cours numériquement et anonymement et évaluez-les en ligne</li> <li>Interrogez les connaissances (préalables), opinions et auto-évaluations des élèves</li> <li>Imprimez les modèles en alternative et <strong>utilisez-les de manière analogique</strong></li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "worksheet_wizard": {
        "description": "Créez des fiches d'exercices avec des tâches générées par l'IA, partagez-les et évaluez-les numériquement",
        "name": "Générer une fiche d'exercices"
      }
    }
  }
}
